module.exports = __webpack_public_path__ + "static/ImportarFuncionarios-63d9315a0e78c09b7e30695d2750ec79.png";